import { Component, HostListener, Input, OnInit } from '@angular/core';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-modal-message',
  templateUrl: './modal-message.component.html',
  styleUrls: ['./modal-message.component.scss'],
  standalone: false
})

export class ModalMessageComponent implements OnInit {

  @Input() title: string;
  @Input() body: string;
  @Input() buttonText : string = 'Ok';

  @Input() bodyList: string[];
  @Input() callbackFunction:Function;

  @Input() onCloseFunction: Function;

  @Input() isFormattedText: boolean = false;

  @Input() bsModalRefId: string | number;


  constructor(public bsModalRef: BsModalService) { }

  ngOnInit(){

  }

  @HostListener('document:keydown.escape', ['$event']) 
  onEscape(event: KeyboardEvent) {
    this.onClose(false); // escape key already hides the modal
  }

  onClose(hideModal: boolean = true) {
    this.bodyList = undefined;
    if (this.onCloseFunction){
      this.onCloseFunction();
    }
    hideModal ? this.bsModalRef.hide(this.bsModalRefId): false;
  }
  ok(){
    this.onClose();
    if (this.callbackFunction != null){
      this.callbackFunction();
    }
  }

}
